// extracted by mini-css-extract-plugin
export default {"confirmModal":"ConfirmModal_confirmModal__uIVU1","circleWrapper":"ConfirmModal_circleWrapper__Kya70"};